"use strict";import{IconSearch as e}from"../src/elements/IconSearch.js";import{defineElement as a}from"@spectrum-web-components/base/src/define-element.js";a("sp-icon-search",e);
//# sourceMappingURL=sp-icon-search.js.map
